/** Rental Leases table columns — shared defs for list + column customizer. */

import { isCalendarDateBeforeToday } from "./dueDateTime";

export const RENTAL_LEASE_STATUS_OPTIONS = ["Active", "Upcoming", "Past"];

export const RENTAL_LEASE_TABLE_COLUMNS = [
  { id: "property_address", label: "Property address" },
  { id: "status", label: "Status" },
  { id: "start_date", label: "Start" },
  { id: "end_date", label: "End" },
  { id: "rent_amount", label: "Rent" },
  { id: "security_deposit", label: "Security deposit" },
  { id: "pet_deposit", label: "Pet deposit" },
  { id: "tenants", label: "Tenants" },
  { id: "landlords", label: "Landlords" },
  { id: "asset_id", label: "Asset" },
];

export const RENTAL_LEASE_TABLE_DEFAULT_VISIBLE = [
  "property_address",
  "status",
  "start_date",
  "end_date",
  "rent_amount",
  "tenants",
  "asset_id",
];

export const RENTAL_LEASE_TABLE_KEY = "rental_leases.table";

export const RENTAL_LEASE_SORT_KEY_TYPES = {
  start_date: "date",
  end_date: "date",
  rent_amount: "number",
  security_deposit: "number",
  pet_deposit: "number",
};

export const RENTAL_LEASE_NUMERIC_COLUMN_IDS = new Set([
  "rent_amount",
  "security_deposit",
  "pet_deposit",
]);

/**
 * True when lease end calendar day is strictly before today (local).
 * @param {unknown} endDate
 * @param {{ today?: import("dayjs").Dayjs }} [options]
 */
export function isLeaseExpiredByEndDate(endDate, options = {}) {
  return isCalendarDateBeforeToday(endDate, options);
}

/**
 * Sum monthly rent for rows with a finite rent_amount.
 * @param {Array<{ rent_amount?: unknown }>} rows
 * @returns {{ totalRent: number, counted: number }}
 */
export function summarizeLeaseRent(rows) {
  let totalRent = 0;
  let counted = 0;
  (rows || []).forEach((row) => {
    const n = Number(row?.rent_amount);
    if (!Number.isFinite(n)) return;
    totalRent += n;
    counted += 1;
  });
  return { totalRent, counted };
}
